module.exports = __webpack_public_path__ + "img/tags-unactive.729d505.svg";